import { displayList } from '../../../utils/storage/storage';

export default function ListFillData() {

 let list = [];
 for(let i = 0; i < displayList.length; i++){
    if(Object.entries(displayList[i].value).length !== 0){
      list.push(displayList[i].pathName);
    }

 }
 return list;
    
 }